<script>
export default {
  name: "HeaderElement",
  props: {
    wrapped: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    prefix: {
      type: String,
      default: undefined
    },
    content: {
      type: String,
      default: undefined
    }
  },
  computed: {
    wrappedStart() {
      return this.wrapped ? "(" : "";
    },
    wrappedEnd() {
      return this.wrapped ? ")" : "";
    }
  }
};
</script>

<template>
  <span v-if="content" class="article-header__element">
    <!-- &#8203 = zero-width space to prevent funky highlighting behavior -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <i>{{ wrappedStart }}{{ prefix }}<span v-html="content"></span>{{ wrappedEnd }}&#8203;</i>
  </span>
</template>
